import React, { useEffect, useState } from "react";
import AOS from "aos";
import feather from "feather-icons";
import "aos/dist/aos.css";
import "./ApkDownload.css";

export default function ApkDownload() {
  const [isAndroid, setIsAndroid] = useState(false);
  const year = new Date().getFullYear();

  useEffect(() => {
    AOS.init({ duration: 800 });
    feather.replace();
    setIsAndroid(/Android/i.test(navigator.userAgent));
  }, []);

  return (
    <div className="apk-wrap">
      <div className="apk-container" data-aos="fade-up">
        <div className="apk-card apk-card-glow">
          <div className="apk-card-body">
            {/* Header */}
            <div className="apk-head">
              <img src="/icon.png" alt="App Icon" className="apk-icon" />
              <div>
                <h1 className="apk-title">Lian Foong</h1>
                <p className="apk-subtitle">Android Application</p>
              </div>
            </div>

            {/* Android notice */}
            {!isAndroid && (
              <div className="apk-note">
                <p>
                  You&apos;re not on Android. Open this page on your Android device:
                  <br />
                  <b>admin.lianfoong.com/app</b>
                </p>
              </div>
            )}

            {/* Download button */}
            <a
              href="/application-ce8c9b3c-c421-4023-8dc1-2fd00ec22d2c.apk"
              download
              className="apk-btn apk-btn-hover"
            >
              <i data-feather="download" className="apk-feather-icon" />
              Download APK
            </a>

            {/* Notes */}
            <div className="apk-notes">
              <h3 className="apk-notes-title">Installation Notes</h3>
              <ul className="apk-list">
                <li>
                  <i data-feather="check-circle" className="apk-li-icon ok" />
                  Requires Android 8.0 or higher
                </li>
                <li>
                  <i data-feather="alert-circle" className="apk-li-icon warn" />
                  Allow installations from unknown sources when prompted
                </li>
                <li>
                  <i data-feather="shield" className="apk-li-icon info" />
                  File size: ~25MB (fast download)
                </li>
              </ul>
            </div>
          </div>

          <div className="apk-card-footer">
            © {year} Lian Foong. All rights reserved.
          </div>
        </div>
      </div>
    </div>
  );
}
